import cookie from 'js-cookie'

/**
 * 解析当前站点ID：优先取cookie中currentHospital的id；
 * 缺失时（如/agent/hospital接口故障期间写入的无id脏数据）通过医院列表按名称匹配恢复，
 * 并同步修复cookie，避免后续再次丢失。
 * @param {Function} fetchHospitals 获取医院列表的方法（如 this.$http.admin.findHospitalName）
 * @returns {Promise<string>} stationId，未取到时返回空字符串
 */
export async function resolveStationId(fetchHospitals) {
  let hospitalObj = {};
  try {
    const hospitalData = cookie.get('currentHospital');
    hospitalObj = hospitalData ? JSON.parse(hospitalData) : {};
  } catch (e) {
    console.error('解析cookie中的医院信息失败:', e);
  }
  if (hospitalObj.id) {
    return hospitalObj.id;
  }
  const hospitalName = hospitalObj.name || '';
  if (hospitalName && typeof fetchHospitals === 'function') {
    try {
      const hospitalList = await fetchHospitals();
      const matched = (hospitalList || []).find(h => h.name === hospitalName);
      if (matched && matched.id) {
        cookie.set('currentHospital', JSON.stringify(matched), { expires: 365 });
        return matched.id;
      }
    } catch (e) {
      console.error('恢复stationId失败:', e);
    }
  }
  return '';
}

export function fullScreen() {
  console.log('fullScreen')
  var element = document.body
  var requestMethod =
    element.requestFullScreen || //W3C
    element.webkitRequestFullScreen || //FireFox
    element.mozRequestFullScreen || //Chrome等
    element.msRequestFullscreen; //IE11
  if (requestMethod) {
    requestMethod.call(element);
  }
}
export function exitFullScreen() {
  var requestMethod =
    document.exitFullScreen || //W3C
    document.webkitExitFullscreen || //FireFox
    document.mozCancelFullScreen || //Chrome等
    document.msExitFullscreen; //IE11
  if (requestMethod) {
    requestMethod.call(document);
  }
}
export function formatResultFunc(key, value) {
  if (key === 'VISION_CHALLENGE') {
    return {
      leftEyeVision: value.leftData,
      rightEyeVision: value.rightData,
      type: "VISION_CHALLENGE"
    };
  } else if (key === 'CONTRAST_SENSITIVITY_TRAINING') {
    console.log('>>>SS', value.data)
    const valueCeil = value.data.map(item => {
      console.log('>>>item', item)
      item.data.forEach(o => {
        o[1] = parseFloat(o[1].toFixed(1))
        console.log('>>>o', o)
      })
      return item
    })
    value.data = valueCeil
    return {
      result: value,
      type: key
    }
  } else {
    return {
      result: value,
      type: key
    };
  }
}



// WEBPACK FOOTER //
// ./src/common/util.js